import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type {
  RegenerateRecoveryCodesRequest,
  RegenerateRecoveryCodesResponse,
} from './2fa.types'

const regenerateRecoveryCodes = async (
  payload: RegenerateRecoveryCodesRequest,
): Promise<RegenerateRecoveryCodesResponse> => {
  const response = await apiClient.post<RegenerateRecoveryCodesResponse>(
    '/v1/administration/user/2fa/recovery-codes',
    payload,
  )
  return response.data
}

export const useRegenerateRecoveryCodes = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (payload: RegenerateRecoveryCodesRequest) =>
      regenerateRecoveryCodes(payload),
    meta: {
      ...feedback,
    },
  })
}
